import _ from 'lodash';

function PermissionService($window, $q, $rootScope, $state, $stateParams, toastr, AppSettings, UserService, AdminService) {
    'ngInject';

    const service = {};

    // 사용자 구분 - 역할에 따라 메인 메뉴를 생성
    service.getMainMenu = function (loginId, uuid) {
        // 사용자 구분과 역할 이름에 따른 메인 메뉴 생성
        AdminService.menus({
            login_id: loginId,
            uuid: uuid
        }).then(function (res) {
            let menus = _.filter(res.data.menus, {
                is_active: true
            });
            console.log('menus', menus);
        }).catch(function (e) {
            console.log('ERROR ' + e);
        });
    };

    // user_type_id 에 따라 사용자 구분 설정
    // 회원가입할 때 아래의 4개 구분으로 나누어짐
    // 선수: player, 지도자: coaching_staff, 팀(단체,회사,협회): team_staff, 팬(일반): fan
    service.getUserType = function (userTypeId) {
        var userType;

        switch (userTypeId) {
            case '1':
                userType = 'player';
                break;

            case '4':
            case '5':
            case '6':
            case '7':
            case '8':
            case '9':
                userType = 'coaching_staff';
                break;

            case '18':  // SA21C parent_id
            case '22':  // 본사관리자
            case '23':  // 최고관리자
                userType = 'sa21c';
                break;

            case '17':  // 후원팬
            case '28':  // 일반팬
            case '281': // 회사 - 주식회사
            case '295': // 회사 - 사단법인
            case '309': // 회사 - 영리법인
            case '323': // 회사 - 개인사업자
            case '337': // 회사 - 기타
                userType = 'fan';
                break;

            default:
                userType = 'team_staff';
                break;
        }

        return userType;
    };

    // 감독-선수 소속팀 관련 수정
    service.getUserType2 = function (userTypeId) {
        var userType;

        switch (userTypeId) {
            case '1':
            case '4':
                userType = 'coach_player';
                break;

            default:
                userType = 'other';
                break;
        }

        return userType;
    };

    // 결제한 상품명으로 해당 대메뉴에 접근 가능한지 검사
    service.mainMenuAccess = function (productName, state, params, userType) {
        if (userType === 'fan') {   // 팬은 결제하지 않음
            return true;
        }
        
        // 모든 대메뉴 접근 가능
        if (
            productName === 'TS 700' || 
            productName === 'TS 50' || 
            productName === 'PS 700' || 
            productName === 'PS 50' || 
            productName === 'FS 700' || 
            productName === 'FS 50' ||
            productName === '케어서비스'        // 케어서비스는 TS 70, PS 70, FS 70 과 같은 권한을 부여함
        ) {
            return true;
        }
        // 아래의 제품들은 아래의 메뉴들에 접근 하지 못함
        else if (
            (
                productName === 'TS 70' || 
                productName === 'PS 70' || 
                productName === 'FS 70'
            ) && (
                state === 'Service.eventRecord' ||      // 경기기록
                state === 'Service.eventAnalysis'       // 경기분석
            )
        ) {
            return false;
        }
        // 아래의 제품들은 아래의 메뉴들에 접근 하지 못함
        else if (
            (
                productName === 'TS 30' ||
                productName === 'TS 7' ||
                productName === 'PS 30' ||
                productName === 'PS 7' ||
                productName === 'FS 30' ||
                productName === 'FS 7'
            ) && (
                state === 'Service.eventRecord' ||      // 경기기록
                state === 'Service.eventAnalysis' ||    // 경기분석
                state === 'Service.playerDetail'     // 선수분석
            )
        ) {
            return false;
        }

        return true;
    };

    // 결제한 상품명으로 해당 소메뉴 또는 기능에 접근 가능한지 검사
    service.subMenuAccess = function() {
        return true;
    };

    // 결제한 상품명으로 해당 메뉴에 접근 가능한지 검사
    service.menuAccess = function ($event, vm, menuName) {
        // $event 가 있는 경우는 메뉴를 클릭하는 경우, $event 가 없는 경우는 메뉴 노출 여부 결정
        if ($event) {
            $event.preventDefault();
        } else {
            var d = $q.defer();
        }

        d.resolve(true);
        
        return d.promise;

        // 지도자/관계자 이외의 구분으로 로그인하였는데 결제가 되지 않은 경우 메뉴 링크를 클릭했을 때의 처리
        if ((vm.appContext.role2 !== 'sa21c' && vm.appContext.role2 !== 'coaching_staff' && vm.appContext.role2 !== 'team_staff') && (!vm.appContext.info.payed || vm.appContext.info.payed === 'N')) {
            if ($event) {
                toastr.error('해당 메뉴를 사용하실 수 없습니다.');
            } else {
                d.resolve(false);
            }
        }
        // 전체 관리자는 메뉴를 열어줌
        else if (vm.appContext.role2 === 'sa21c') {
            if ($event) {
                $($event.target).trigger('click');
            } else {
                d.resolve(true);
            }
        }
        // 테스트 계정의 경우 메뉴를 열어줌
        else if (vm.appContext.user.login_id.match('testuser')) {
            if ($event) {
                $($event.target).trigger('click');
            } else {
                d.resolve(true);
            }
        }
        else {
            // 결제를 한 경우에는 결제한 상품에 따라 처리

            // 결제 이력 조회
            var payHistoryData = {
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid
            };
            UserService.paymentHistory(payHistoryData).then(function(res) {
                // 결제내역이 있는 경우
                if (res.data.list.length) {
                    // 결제내역 배열의 가장 끝 상품명 조회 - 결제 사용자/결제받은 사용자 API 수정 후 수정 필요
                    var productName = res.data.list[res.data.list.length - 1].product_name;
                    
                    // 이동하려고 하는 메인메뉴가 상품명에 맞으면 이동, 맞지 않으면 이동하지 않음
                    if (
                        (
                            productName === 'TS 70' ||
                            productName === 'PS 70' ||
                            productName === 'FS 70'
                        ) && (
                            menuName === '스카우팅' ||
                            menuName === '이적' ||
                            menuName === '발탁' ||
                            menuName === '상대팀분석' ||
                            menuName === '상대선수분석' ||
                            menuName === '경기기록' ||
                            menuName === '경기분석'
                        ) ||
                        (
                            productName === 'TS 7' ||
                            productName === 'PS 7' ||
                            productName === 'FS 7'
                        ) && (
                            menuName === '웨어러블' ||
                            menuName === '메디컬체크' ||
                            menuName === '경기기록' ||
                            menuName === '경기분석' ||
                            menuName === '선수분석'
                        )
                    ) {
                        if ($event) {
                            toastr.error('해당 메뉴를 사용하실 수 없습니다.');
                        } else {
                            d.resolve(false);
                        }
                    } else {
                        if ($event) {
                            $($event.target).trigger('click');
                        } else {
                            d.resolve(true);
                        }
                    }
                }
                // 결제내역이 없는 경우
                else {
                    if ($event) {
                        toastr.error('해당 메뉴를 사용하실 수 없습니다.');
                    } else {
                        d.resolve(false);
                    }
                }
            });
        }

        return d.promise;
    };

    // 권한 확인
    service.permissionCheck = function(vm, state) {
        var d = $q.defer();

        // 지도자/관계자 이외의 구분으로 로그인하였는데 결제가 되지 않은 경우 메뉴 링크를 클릭했을 때의 처리
        if ((vm.appContext.role2 !== 'sa21c' && vm.appContext.role2 !== 'coaching_staff' && vm.appContext.role2 !== 'team_staff') && (!vm.appContext.info.payed || vm.appContext.info.payed === 'N')) {
            // d.reject(null);
            d.resolve(true);
        }
        // 전체 관리자는 메뉴를 열어줌
        else if (vm.appContext.role2 === 'sa21c') {
            d.resolve(true);
        }
        else {
            // 결제를 한 경우에는 결제한 상품에 따라 처리

            d.resolve(true);
            return d.promise;

            // 결제 이력 조회
            var payHistoryData = {
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid
            };
            UserService.paymentHistory(payHistoryData).then(function(res) {
                // 결제내역이 있는 경우
                if (res.data.list.length) {
                    // 결제내역 배열의 가장 끝 상품명 조회 - 결제 사용자/결제받은 사용자 API 수정 후 수정 필요
                    var productName = res.data.list[res.data.list.length - 1].product_name;
                    
                    // 이동하려고 하는 메인메뉴가 상품명에 맞으면 이동, 맞지 않으면 이동하지 않음
                    if (service.mainMenuAccess(productName, state, false, vm.appContext.role2)) {
                        d.resolve(true);
                    } else {
                        d.reject(null);
                    }
                }
                // 결제내역이 없는 경우
                else {
                    d.reject(null);
                }
            }).catch(function(err) {
                console.log(err);
                d.reject(null);
            });
        }

        return d.promise;
    };

    // 권한을 확인한 후 메뉴 이동
    service.goToMenu = function ($event, vm, state, params) {
        $event.preventDefault();

        // 무료 사용자 메뉴 이동이 되지 않도록 처리

        // 20210831 현재 유료 결제로 로그인이 허용된팀
        // 유료결제팀
        // 1. 경기평택시티즌유소년축구단 (초등)   team_id: 27504
        // 2. 서울노원R.FC (초등)               team_id: 27516
        // 3. 강원원주리더스 (초등)             team_id: 27478
        // 4. 청주프로비티FC (초등)             team_id: 27651
        // 5. 최강희축구교실 / FC아쏘 (초등)     team_id: 27654

        // 데이터바우처
        // 1. 경기용인레이번스U15 (중등)        team_id: 26607
        // 2. 경기안산아르마다FCU12 (초등)      team_id: 27619
        // 3. 경기양주탑클래스U12 (초등)        team_id: 27456

        // 국가대표팀                         team_id: 53

        if (
            vm.appContext.role2 !== 'sa21c' && 
            vm.appContext.info.team_id != '27504' &&
            vm.appContext.info.team_id != '27516' &&
            vm.appContext.info.team_id != '27478' &&
            vm.appContext.info.team_id != '27651' &&
            vm.appContext.info.team_id != '27654' &&
            vm.appContext.info.team_id != '26607' &&
            vm.appContext.info.team_id != '27619' &&
            vm.appContext.info.team_id != '27456' &&
            vm.appContext.info.team_id != '53'
        ) {
            alert('현재 무료 유저입니다.\n유료 결제를 통해서 리뉴얼된 새로운 기능을 사용해보세요');
        } else {
            $state.go(state, params ? params : {});
        }

        return;

        // 지도자/관계자 이외의 구분으로 로그인하였는데 결제가 되지 않은 경우 메뉴 링크를 클릭했을 때의 처리
        if ((vm.appContext.role2 !== 'sa21c' && vm.appContext.role2 !== 'coaching_staff' && vm.appContext.role2 !== 'team_staff') && (!vm.appContext.info.payed || vm.appContext.info.payed === 'N')) {
            toastr.error("<br /><button type='button' id='payment-confirmation-yes' class='w3-btn w3-tiny w3-blue'>예</button>&nbsp;&nbsp;&nbsp;<button type='button' id='payment-confirmation-no' class='w3-btn w3-tiny w3-black'>아니오</button>",'결제창으로 이동하시겠습니까?', {
                closeButton: true,
                allowHtml: true,
                timeOut: 100000,
                extendedTimeOut: 100000,
                onShown: function (toast) {
                    $("#payment-confirmation-yes").off('click').on('click', function(){
                        $state.go('Service.member', { 'target': 'MyInfo', 'team_id': vm.appContext.info.team_id, 'popup': 1 });
                    });

                    // $("#payment-confirmation-no").off('click').on('click', function(){
                    //     console.log('clicked no');
                    // });
                }
            });
        }
        // 전체 관리자는 메뉴를 열어줌
        else if (vm.appContext.role2 === 'sa21c') {
            $state.go(state, params ? params : {});
        }
        else {
            // 결제를 한 경우에는 결제한 상품에 따라 처리

            // 결제 이력 조회
            var payHistoryData = {
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid
            };
            UserService.paymentHistory(payHistoryData).then(function(res) {
                // 결제내역이 있는 경우
                if (res.data.list.length) {
                    // 결제내역 배열의 가장 끝 상품명 조회 - 결제 사용자/결제받은 사용자 API 수정 후 수정 필요
                    var productName = res.data.list[res.data.list.length - 1].product_name;
                    
                    // 이동하려고 하는 메인메뉴가 상품명에 맞으면 이동, 맞지 않으면 이동하지 않음
                    if (service.mainMenuAccess(productName, state, params, vm.appContext.role2)) {
                        $state.go(state, params ? params : {});
                    } else {
                        toastr.error('해당 메뉴를 사용하실 수 없습니다.');
                    }
                }
                // 결제내역이 없는 경우
                else {
                    toastr.error('해당 메뉴를 사용하실 수 없습니다.');
                }
            });
        }
    };

    return service;

}

export default {
    name: 'PermissionService',
    fn: PermissionService
};
